import { render, staticRenderFns } from "./BillingAccount.vue?vue&type=template&id=dd1ce8d2&scoped=true&"
import script from "./BillingAccount.vue?vue&type=script&lang=js&"
export * from "./BillingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1ce8d2",
  null
  
)

export default component.exports